import styled from 'styled-components'

import { media } from '../../../utils/style-utils'

export const GamesBaseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);

  ${media.xxl`
    grid-template-columns: repeat(5, 1fr);
  `}
  ${media.xs`
    grid-template-columns: repeat(3, 1fr);
  `}
`
